export const formatPrice = (amount, currency) => {
  if (currency === 'IQD') return `${Number(amount).toLocaleString()} د.ع`;
  return `$${Number(amount).toLocaleString()}`;
};

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
};
